import { isEmpty } from "lodash";
import store from "../../configureStore";
import { RENDER_MESSAGE_TYPE_HTML } from "../../constants";


export const handleMessageTypeHtml = (conversationId, message) => (dispatch) => {
    if(!message.options?.embedded) return

    const tabStack = store.getState().tabStack || {};
    const hasExistingState = !isEmpty(tabStack[conversationId]);

    const updatedData = hasExistingState
        ? updateExistingTabStack(conversationId, message, tabStack)
        : initializeTabStack({}, message);

    dispatch({
        type: RENDER_MESSAGE_TYPE_HTML,
        data: {
            [conversationId]: updatedData,
        },
    });
};

const updateExistingTabStack = (conversationId, message, state) => {
    const data = state[conversationId];
    return Array.isArray(data?.components) && data.components.length > 0
        ? appendToTabStack(data, message)
        : initializeTabStack(data, message);
};


const appendToTabStack = (stackData, message) => {
    const withUpdatedTabs = reconcileExistingTabs(stackData, message);
    return addNewTabIfApplicable(withUpdatedTabs, message);
};


const reconcileExistingTabs = (stackData, message) => {
    const updatedComponents = stackData.components.map((tab) => {
        const isSameTab = tab?.options?.tabId === message?.options?.tabId;

        if (isSameTab) {
            const shouldUpdateTab = !message?.message?.options?.updateInBackground;
            return {
                ...message,
                ...(shouldUpdateTab && { selectedTab: message?.options?.tabId })
            };
        }

        return tab;
    });

    return {
        ...stackData,
        components: updatedComponents,
    };
};


const addNewTabIfApplicable = (data, message) => {
    const tabIds = data.components.map(c => c.options?.tabId);
    const isNewTab = !tabIds.includes(message?.options?.tabId);

    if (isNewTab) {
        return {
            ...data,
            components: [...data.components, message],
            selectedTab: message?.options?.tabId,
        };
    }

    return data;
};


const initializeTabStack = (data = {}, message) => {
    const isPullDown = message?.options?.pullDown;
    const updateInBackground = message?.message?.options?.updateInBackground;

    if (isPullDown) {
        return {
            ...data,
            components: [],
            pullDownMenuComponent: message,
        };
    }

    return {
        ...data,
        components: [message],
        ...(updateInBackground ? {} : { selectedTab: message?.options?.tabId }),
    };
};
